import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { ROLE_LABELS } from '../utils/roleDisplay';
import Icon from './Icon';

// "צפייה כ…" entries for a page's ⋮ menu (owner decision 2026-10-03: the
// preview belongs in every page's own menu, not only the account menu).
// Renders nothing for anyone who cannot preview. `onDone` closes the host menu.
export function ViewAsMenuItems({ onDone }) {
  const { viewAsTargets = [], viewAs, setViewAs, isRealAdmin, restaurantId } = useAuth() || {};
  if (!viewAsTargets.length || !setViewAs) return null;
  const needsRestaurant = isRealAdmin && !restaurantId;
  const pick = (role) => { onDone?.(); setViewAs(role); };
  return (
    <>
      <div className="page-menu-divider" role="separator" />
      <div className="page-menu-label">צפייה כ…</div>
      {viewAsTargets.map(role => (
        <button
          key={role}
          type="button"
          className="page-menu-item"
          disabled={needsRestaurant || viewAs === role}
          aria-pressed={viewAs === role}
          onClick={() => pick(role)}
        >
          <Icon name="eye" size={15} /> {ROLE_LABELS[role]}
        </button>
      ))}
      {viewAs && (
        <button type="button" className="page-menu-item page-menu-item--strong" onClick={() => pick(null)}>
          חזרה לתצוגה שלי
        </button>
      )}
    </>
  );
}

// A ⋮ of its own for pages that have no page-level menu yet.
export default function PageViewAsMenu() {
  const { viewAsTargets = [] } = useAuth() || {};
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);
  if (!viewAsTargets.length) return null;
  return (
    <div className="page-menu">
      <button
        type="button"
        className="page-menu-trigger"
        aria-label="פעולות נוספות"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >⋮</button>
      {open && (
        <>
          <div className="menu-backdrop" onClick={() => setOpen(false)} />
          <div className="page-menu-panel">
            <ViewAsMenuItems onDone={() => setOpen(false)} />
          </div>
        </>
      )}
    </div>
  );
}
